import { Card, CardContent, Stack } from '@mui/material'
import { SkeletonText } from 'utoniq-ui'

import { Organism, OrganismFrame } from '@/core/architecture'

export const PurchaseItemSkeleton: Organism = () => (
  <OrganismFrame>
    <Card sx={{ borderRadius: 2 }}>
      <CardContent sx={{ p: 5, '&:last-child': { pb: 5 } }}>
        <Stack direction="row" spacing={4} alignItems="center" sx={{ pb: 1 }}>
          <Stack flex={1}>
            <SkeletonText variant="medium" />
          </Stack>
          <Stack flex={2}>
            <SkeletonText variant="medium" />
          </Stack>
        </Stack>
        <Stack spacing={2}>
          <Stack direction="row" spacing={4} flex={1}>
            <Stack flex={1}>
              <SkeletonText variant="medium" />
            </Stack>
            <Stack flex={2} />
          </Stack>
          <Stack>
            {Array.from(Array(3).keys()).map(index => (
              <Stack key={index} direction="row" spacing={2}>
                <Stack flex={3}>
                  <SkeletonText variant="small" />
                </Stack>
                <Stack flex={1}>
                  <SkeletonText variant="small" />
                </Stack>
              </Stack>
            ))}
          </Stack>
        </Stack>
        <Stack>
          <SkeletonText variant="medium" width="25%" />
          <SkeletonText variant="medium" width="25%" />
        </Stack>
      </CardContent>
    </Card>
  </OrganismFrame>
)
